import { listen, sendLocal } from "../channels";
import { filterMessage } from "../helpers";
import { isData } from "../message";
import { isPlatformMessage } from "../messages/platform";
import { platformRequestMessage } from "../messages/platform-request";
var windowPf = window;
export var getPlatform = function getPlatform() {
  return new Promise(function (res, rej) {
    var timeOut = setTimeout(function () {
      return rej("getPlatform timed out");
    }, 10 * 1000);
    var unsub = listen(filterMessage(isPlatformMessage)(function (message) {
      if (isData(message)) {
        var platform = message.payload;
        unsub();
        clearTimeout(timeOut);
        windowPf.meta.platform = platform;
        res(platform);
      }
    }));
    sendLocal(platformRequestMessage());
  });
};
export var getPlatformSync = function getPlatformSync() {
  return windowPf.meta.platform;
};